import { IPost } from "src/libs/interfaces/layouts";
import actions from "src/modules/pe-basic-module/data/actions";
import { GET_FEED_ACTION } from "src/modules/pe-basic-module/data/actionTypes";
import { useDataStore } from "src/modules/pe-basic-module/data/store";
import { useEffect } from "react";

export default function useTestCategories() {
    const PETestCategory: IPost     = useDataStore((state: any) => state.PETestCategory || [] )
    useEffect(() => {
        if(!PETestCategory.length) {
            actions(GET_FEED_ACTION, {
                data_type: "PETestCategory"
            })
        }
    }, [])
    return PETestCategory
}